export const locale = {
    lang: 'ar',
    data: {
        TEAM: 'مناقشة الفريق',
        CONVERSATION: 'ابدأ محادثة بكتابة رسالتك أدناه',
        TYPE: 'إكتب رسالتك',
        ANIMATOR_BADGE: 'مُيَسّرْ'
    }
};
